import {createContext, useContext} from 'react'

/** True while Guidex shows its tour selection modal or a tour step. */
export const GuidexActivityContext = createContext(false)

const GUIDEX_UI_SELECTOR = '[data-guidex], [data-guidex-editor], .guidex-launcher'

/**
 * Guidex renders its UI in portals outside the app and doesn't stop mousedown events, so
 * click-outside handlers (e.g. drawers) must ignore interactions with tours, the modal and the editor.
 */
export const useIsGuidexInteraction = () => {
  const isGuidexActive = useContext(GuidexActivityContext)

  return (event: Event) =>
    isGuidexActive || (event.target instanceof Element && !!event.target.closest(GUIDEX_UI_SELECTOR))
}
